import { SectionToggleState, useSectionHelper } from "hooks";
import { FormCollapse } from "components/Form";
import React from "react";
import { Section } from "containers/Settings/RuleBooks/Rules/CustomRules/constants";
import { GeneralHeader } from "./GeneralHeader";
import { GeneralForm } from "./GeneralForm";

interface GeneralSectionProps {
  sectionToggleState: SectionToggleState;
  billingTags: Array<{ id: string; name: string }>;
  categories: Array<string>;
  fullInputPath: string;
  isMasterRule: boolean;
  ruleId: string;
}

export function GeneralSection(props: GeneralSectionProps) {
  const {
    billingTags,
    categories,
    isMasterRule,
    fullInputPath,
    ruleId,
    sectionToggleState,
  } = props;
  const { isOpen, onToggle } = useSectionHelper(
    sectionToggleState,
    Section.GENERAL,
  );

  const header = <GeneralHeader />;

  return (
    <FormCollapse
      isOpen={isOpen}
      onToggle={onToggle}
      header={header}
      dataTour={isOpen ? "hideGeneral" : "showGeneral"}
    >
      <GeneralForm
        billingTags={billingTags}
        categories={categories}
        fullInputPath={fullInputPath}
        isMasterRule={isMasterRule}
        ruleId={ruleId}
      />
    </FormCollapse>
  );
}
